if (!window.customElements.get('delta-swiper')) {
    customElements.define('delta-swiper', class extends HTMLElement {
      constructor() {
          super();
          this.swiper = null;
          this.$section = null;
      }
  
      connectedCallback() {
          this.$section = $(this);
          
          // Check if only effective in mobile mode
          const mobileOnly = this.getAttribute('data-mobile') === 'true';
          if (mobileOnly && window.innerWidth > 768) {
              return; // If set to only work in mobile mode and currently in desktop mode, don't initialize
          }
          
          // Initialize Swiper
          this.initSwiper();
          // Window resize event
          this.resizeHandler = () => {
              const mobileOnly = this.getAttribute('data-mobile') === 'true';
              // If set to only work in mobile mode
              if (mobileOnly) {
                  if (window.innerWidth > 768 && this.swiper) {
                      // Destroy swiper in desktop mode
                      this.swiper.destroy(true, true);
                      this.swiper = null;
                      return;
                  } else if (window.innerWidth <= 768 && !this.swiper) {
                      // Re-initialize swiper in mobile mode
                      this.initSwiper();
                  }
              }
              
              if (this.swiper) {
                  if (window.innerWidth > 768) {
                      setTimeout(() => this.updatePageContent(), 100);
                  } else {
                      const pageContent = this.$section.find(".swiper-page-content")[0];
                      if (pageContent) {
                          pageContent.style.top = "";
                      }
                  }
                  this.setTabsWidth();
              }
          };
          
          window.addEventListener("resize", this.resizeHandler);
  
          // Initialize after page load
          this.loadHandler = () => {
              this.updateTabs();
              if (window.innerWidth > 768) {
                  setTimeout(() => this.updatePageContent(), 100);
              }
              this.setTabsWidth();
          };
          
          window.addEventListener("load", this.loadHandler);
  
          // Initialize
          setTimeout(() => {
              this.updateTabs();
              const $firstTab = this.$section.find(".tab-item").first();
              const $indicator = this.$section.find(".active-indicator");
              
              if ($firstTab.length && $indicator.length) {
                  const width = $firstTab.find(".tab-text").outerWidth();
                  const left = $firstTab.position().left;
                  $indicator.css({
                      left: left + "px",
                      width: width + "px"
                  });
              }
          }, 0);
      }
  
      // Initialize Swiper method
      initSwiper() {
          if (this.swiper) {
              this.swiper.destroy(true, true);
          }
          
          this.swiper = new Swiper(this.$section.find(".swiper-container")[0], {
              centeredSlides: true,
              loop: true,
              loopedSlides: 3,
              autoplay: {
                  delay: 5000,
                  disableOnInteraction: false
              },
              pagination: {
                  el: this.$section.find(".swiper-pagination")[0],
                  clickable: true
              },
              navigation: {
                  nextEl: this.$section.find(".swiper-button-next")[0],
                  prevEl: this.$section.find(".swiper-button-prev")[0]
              }
          });
  
          // Tab click switching
          this.$section.find(".tab-item").on("click", () => {
              if (!this.swiper) return;
              const index = $(event.target).index();
              this.swiper.slideToLoop(index);
          });
  
          // Left/Right button controls
          this.$section.find(".left-btn").on("click", () => {
              if (this.swiper) this.swiper.slidePrev();
          });
  
          this.$section.find(".right-btn").on("click", () => {
              if (this.swiper) this.swiper.slideNext();
          });
  
          // Slide change event
          this.swiper.on("slideChange", () => {
              this.updateTabs();
              
              // Video playback control
              this.$section.find(".swiper-slide").each((index, slide) => {
                  const video = $(slide).find("video")[0];
                  if (video) {
                      if (index === this.swiper.activeIndex) {
                          if (video.readyState === 0) video.load();
                          video.play().catch(err => console.log("Autoplay prevented:", err));
                      } else {
                          video.pause();
                      }
                  }
              });
              
              if (window.innerWidth > 768) {
                  this.updatePageContent();
              }
          });
  
          // Autoplay progress bar
          this.swiper.on("autoplayTimeLeft", (swiper, time, progress) => {
              const pagination = this.$section.find(".swiper-pagination")[0];
              if (pagination) {
                  pagination.style.setProperty("--swiper-progress", `${(1 - progress) * 100}%`);
              }
          });
      }
  
      disconnectedCallback() {
          if (this.swiper) {
              this.swiper.destroy(true, true);
          }
          window.removeEventListener("resize", this.resizeHandler);
          window.removeEventListener("load", this.loadHandler);
      }
  
      // Update tabs status
      updateTabs() {
          if (!this.swiper) return;
          
          const realIndex = this.swiper.realIndex;
          const dataSectionSelector = this.getAttribute("data-section");
          const realNodeSection = dataSectionSelector ? this.$section.closest(dataSectionSelector) : this.$section;
          realNodeSection.find(".tab-item").removeClass("active").eq(realIndex).addClass("active");
          
          const $activeTab = this.$section.find(".tab-item").eq(realIndex);
          const $indicator = this.$section.find(".active-indicator");
          const $tabsContainer = this.$section.find(".extract-tabs");
              
              if ($activeTab.length && $indicator.length && $tabsContainer.length) {
                  const tabWidth = $activeTab.find(".tab-text").outerWidth();
                  const tabLeft = $activeTab[0].offsetLeft;
                  
              // Update indicator position
              $indicator.css({
                  left: tabLeft + "px",
                  width: tabWidth + "px"
              });
              
              // Scroll tabs container to make current tab visible
              const containerWidth = $tabsContainer.outerWidth();
              const scrollLeft = $tabsContainer.scrollLeft();
              const tabStart = tabLeft;
              const tabEnd = tabStart + tabWidth;
              const visibleEnd = scrollLeft + containerWidth;
              
              $tabsContainer.stop(true, false);
              
              if (tabStart < scrollLeft) {
                  $tabsContainer.animate({ scrollLeft: tabStart - 20 }, 200);
              } else if (tabEnd > visibleEnd) {
                  $tabsContainer.animate({ scrollLeft: tabEnd - containerWidth + 20 }, 200);
              }
          }
      }
  
      // Update page content position (desktop)
      updatePageContent() {
          const pageContent = this.$section.find(".swiper-page-content")[0];
          const container = this.$section.find(".swiper-container")[0];
          
          if (pageContent && container && this.swiper.slides) {
              const activeIndex = this.swiper.activeIndex;
              const activeSlide = this.swiper.slides[activeIndex];
              
              if (activeSlide) {
                  const slideTitle = activeSlide.querySelector(".swiper-slide-title");
                  if (slideTitle) {
                      const titleRect = slideTitle.getBoundingClientRect();
                      const containerRect = container.getBoundingClientRect();
                      const splaceRect = this.$section.find(".splace-content")[0].getBoundingClientRect();
                      const offset = titleRect.top - containerRect.top;
                      
                      pageContent.style.top = (containerRect.top - splaceRect.top + offset) + "px";
                  }
              }
          }
      }
  
      // Set tabs width (responsive)
      setTabsWidth() {
          if (window.innerWidth <= 768) {
              const tabsContainer = this.$section.find(".extract-tabs")[0];
              if (tabsContainer) {
                  const $tabs = this.$section.find(".tab-item");
                  let totalWidth = 0;
                  let totalGap = 0;
                  
                  $tabs.each((index, tab) => {
                      totalWidth += tab.offsetWidth;
                      if (index < $tabs.length - 1) {
                          totalGap += 40;
                      }
                  });
                  
                  let finalWidth = totalWidth + totalGap;
                  if (window.innerWidth > finalWidth) {
                      finalWidth = window.innerWidth - 40;
                  }
                  
                  tabsContainer.style.setProperty("--tabs-width", finalWidth + "px");
                  tabsContainer.style.setProperty("--tabs-left", "20px");
              }
          } else {
              const tabsContainer = this.$section.find(".extract-tabs")[0];
              if (tabsContainer) {
                  tabsContainer.style.setProperty("--tabs-width", "100%");
                  tabsContainer.style.setProperty("--tabs-left", "0");
              }
          }
      }
    });
  }